import React from 'react';
import { TopNav } from '../components/TopNav';
import { SiteFooter } from '../components/SiteFooter';
import { HeroSection } from '../components/HeroSection';
import { IntegrationsSection } from '../components/IntegrationsSection';
import { LandingFeatureArticles } from '../components/feature/LandingFeatureArticles';
import { LearnMoreSection } from '../components/LearnMoreSection';
import { CtaSection } from '../components/CtaSection';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-black text-text-primary antialiased">
      <TopNav />
      <HeroSection />

      <div className="pt-30">
        <IntegrationsSection />
      </div>

      <LandingFeatureArticles />

      <div className="pt-30">
        <LearnMoreSection />
      </div>

      <CtaSection />
      <SiteFooter />
    </div>
  );
}
